import { render } from "./FieldCheckboxGroup.vue?vue&type=template&id=457a2262"
import script from "./FieldCheckboxGroup.vue?vue&type=script&lang=js"
export * from "./FieldCheckboxGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/alexey/mv/mortgageware/vendor/sudoux/cms/Sudoux/Cms/FormBundle/Resources/views/Vuejs/Apps/formbuilder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QOptionGroup});
